var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":function($event){return _vm.encrypt('15367978596','mq#cUX@d')}}},[_vm._v("userrname")]),_c('button',{on:{"click":function($event){return _vm.encrypt('a1234565','mq#cUX@d')}}},[_vm._v("passwd")])])
}
var staticRenderFns = []

export { render, staticRenderFns }